/* global YT */
import $ from 'jquery';
import slickCarousel from 'slick-carousel';

class LightboxGallery {
    constructor() {
        this.$slideshows = $('.js-slideshow');

        // Loop through each slideshow and initialise separate slideshows.
        for (let i = 0; i < this.$slideshows.length; i++) {
            const $slideshow = $(this.$slideshows[i]);

            // Skip any fullscreen/popup slideshows, we'll only open those when needed.
            if (!$slideshow.hasClass('js-slideshow--fullscreen')) {
                LightboxGallery.initSlideshow($slideshow);
            }
        }

        // Events.
        $('.js-image-gallery-images a').on('click', $.proxy(this.imageGalleryClick, this));
        $('.js-slideshow-close').on('click', $.proxy(this.closeSlideshowButtonClick, this));

        // Keyboard events.
        $(document).keyup((e) => {
            // Escape key.
            if (e.keyCode === 27) {
                this.closeSlideshows();
            }

            // Left key.
            if (e.keyCode === 37) {
                this.prevSlide();
            }

            // Right key.
            if (e.keyCode === 39) {
                this.nextSlide();
            }
        });
    }

    /**
     * Initialise a single slideshow.
     *
     * @param $slideshow Jquery object with .js-slideshow,
     * @param initialSlideNumber Which slide the slideshow should start on.
     */
    static initSlideshow($slideshow, initialSlideNumber = 0) {
        const $slides = $slideshow.find('.js-slideshow-slides');
        const $captions = $slideshow.find('.js-slideshow-captions');

        /**
         * Slick Carousels.
         *
         * The first carousel is a slider of images.
         * The second carousel is a slider of captions.
         *
         * The captions slider acts as a nav for the images slider.
         * The images slider acts as a nav for the captions slider.
         *
         * Inspired by: https://codepen.io/Svarnoy85/pen/NzQPpe
         */

        // Load the slick-carousel of images.
        $slides.slick({
            adaptiveHeight: true,
            asNavFor: $captions[0],
            fade: true,
            infinite: false,
            slidesToScroll: 1,
            speed: 200,
            prevArrow: $slides.closest('.js-slideshow-wrapper').find('.js-slideshow-prev')[0],
            nextArrow: $slides.closest('.js-slideshow-wrapper').find('.js-slideshow-next')[0],
            initialSlide: initialSlideNumber,
        });

        // Load the slick-carousel of captions and credits.
        $captions.slick({
            adaptiveHeight: true,
            arrows: false,
            asNavFor: $slides[0],
            fade: true,
            infinite: false,
            slidesToScroll: 1,
            speed: 200,
            initialSlide: initialSlideNumber
        });

        // Add event listener for next/prev button click.
        $slides.closest('.js-slideshow-wrapper').find('.js-slideshow-next, .js-slideshow-prev').on('click', $.proxy(this.pauseVideos, this));
    }

    /**
     * Close a specific slideshow
     *
     * @param $slideshow Element with .js-slideshow
     */
    static closeSlideshow($slideshow) {
        // Hide the Slideshow
        $slideshow.removeClass('is-open');

        // Destroy the Slick slider.
        const $slides = $slideshow.find('.js-slideshow-slides');
        const $captions = $slideshow.find('.js-slideshow-captions');

        if ($slides[0].hasOwnProperty('slick')) {
            $($slides[0]).slick('unslick');
        }

        if ($captions[0].hasOwnProperty('slick')) {
            $($captions[0]).slick('unslick');
        }
    }

    /**
     * Pause all videos.
     */
    static pauseVideos() {
        const videoFrames = document.querySelectorAll('.js-slideshow-embed iframe');
        // Loop through each iframe
        videoFrames.forEach((iframe) => {
            // Post message to pause the video.
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        });
    }

    /**
     * If an image gallery item has been clicked, open a full screen slideshow.
     *
     * @param e Event
     */
    imageGalleryClick(e) {
        e.preventDefault();

        const $elem = $(e.currentTarget);
        const $slideshow = $elem.closest('.js-image-gallery').find(this.$slideshows);

        // Show the slideshow.
        $slideshow.addClass('is-open');

        // Init slick-carousel.
        LightboxGallery.initSlideshow($slideshow, $elem.index());
    }

    /**
     * Close all slideshows.
     */
    closeSlideshows() {
        for (let i = 0; i < this.$slideshows.length; i++) {
            const $slideshow = $(this.$slideshows[i]);

            LightboxGallery.closeSlideshow($slideshow);
        }
    }

    /**
     * Individual Slideshow's close button click action
     *
     * @param e Event
     */
    closeSlideshowButtonClick(e) {
        const $elem = $(e.currentTarget);
        const $slideshow = $elem.closest(this.$slideshows);

        LightboxGallery.closeSlideshow($slideshow);
    }

    /**
     * Go to the next slide of the fullscreen slideshow.
     */
    nextSlide() {
        this.activeSlideshowNavigate('slickNext');
    }

    /**
     * Go to the prev slide of the fullscreen slideshow.
     */
    prevSlide() {
        this.activeSlideshowNavigate('slickPrev');
    }

    /**
     * Find the active slideshow and navigate.
     *
     * @param direction slideNext or slidePrev.
     */
    activeSlideshowNavigate(direction) {
        const $slideshow = this.$slideshows.filter('.js-slideshow--fullscreen.is-open');

        if ($slideshow.length) {
            const $slides = $slideshow.find('.js-slideshow-slides');

            if ($slides[0].hasOwnProperty('slick')) {
                $($slides[0]).slick(direction);
            }
        }
    }
}

export default LightboxGallery;
